import React, { FC, memo, useState } from 'react';
import FnThumbnail from '../FnThumbnail';
import ImageReview from '../../../features/ImageReview';

type TProps = {
  image: string;
  className?: string;
};

const ImageWithReviewNative: FC<TProps> = ({ image, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleImageClick = () => {
    setIsOpen(true);
  };
  const handleCloseClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <FnThumbnail src={image} onClick={handleImageClick} className={className} />
      {isOpen && image && <ImageReview images={[image]} onClose={handleCloseClick} />}
    </>
  );
};

export default memo(ImageWithReviewNative);
